import React from 'react';
import { Box, } from '@mui/material';
import { formatDateLong } from '../../../services/apiServices';


const tableStyles = {
    border: '1px solid black',
    padding: '8px',
};

const CoaPrintFirst = ({ invoiceNo, invoiceData, companyBanks, shippingmark, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const conculation = invoiceData?.conculation || "";
    const analyst = invoiceData?.analyst || "";
    const examiner = invoiceData?.examiner || "";
    const approved = invoiceData?.approved || "";

    const mfgDate = formatDateLong(invoiceData?.mfgDate || "");
    const expiryDate = formatDateLong(invoiceData?.expiryDate || "");
    const testDate = formatDateLong(invoiceData?.testDate || "");
    const quantity = invoiceData?.quantity || "";
    const packageInv = invoiceData?.package || "";

    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const productName = invoiceData?.product?.productName || '';

    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = shippingBooking?.portOfLoading || '';
    const portOfDestination = shippingBooking?.portOfDestination || '';
    // Extract particulars from invoice data
    const particulars = invoiceData?.particulars || [];
    // Map the particulars data to a format suitable for the table
    const particularData = particulars.map((particular, index) => ({
        sn: index + 1,
        items: particular.items || '',
        standard: particular.standard || '',
        result: particular.result || '',
        levelId: particular.coaLevel.title || '',
    }));
    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '50px', }}>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: '20px',
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: 'uppercase' }}>
                            Certificate of Analysis (COA)
                        </p>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            width: '100%',
                        }}
                    >
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', marginTop: "50px" }}>
                            <div>
                                <div  >Consignee: <strong>{customerName}</strong> ,<br /></div>
                                <span>
                                    {billingStreet && `${billingStreet},`}
                                    <br />
                                    {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                    {billingPincode && ` - ${billingPincode}`}
                                </span><br />
                                <span >Mobile:</span>  <span>{customerMobile}</span> &nbsp;
                                <span >Email:</span> <span>{customerEmail}</span>
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: '4px',
                                textAlign: 'left',
                            }}
                        >
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                                <div  >Invoice No:</div>
                                <div>{invoiceNo}</div>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                                <div  >Date:</div>
                                <div>{invoiceDate}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'block', alignItems: 'center', paddingTop: "20px", paddingBottom: "20px" }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <div  >Discription of good:   {productName}  </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <div  >Quantity: {quantity}  </div>
                    </div>
                </div>
                <div style={{ display: 'block', alignItems: 'center', paddingTop: "20px", paddingBottom: "20px" }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <div  >The results of inspection and quarantine: </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <div  >We inspect the goods with results as follows:  </div>
                    </div>
                </div>

                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <thead style={{ backgroundColor: "#ededed" }}>
                        <tr>
                            <th style={{ textAlign: 'left', width: "15%" }}>items</th>
                            <th style={{ textAlign: 'left', width: "15%" }}>Element</th>
                            <th style={{ textAlign: 'left', width: "25%" }}>standard Required</th>
                            <th style={{ textAlign: 'left', width: "15%" }}>unit</th>
                            <th style={{ textAlign: 'left', width: "15%" }}>result</th>
                            <th style={{ textAlign: 'left', width: "15%" }}>level</th>
                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "capitalize" }}>
                        {particularData.map((row, index) => (
                            <tr key={index}>
                                <td style={{ textAlign: 'left' }}>{row.items}</td>
                                <td style={{ textAlign: 'left' }}> </td>
                                <td style={{ textAlign: 'left' }}>{row.standard}</td>
                                <td style={{ textAlign: 'left' }}>  </td>
                                <td style={{ textAlign: 'left' }}>{row.result}</td>
                                <td style={{ textAlign: 'left' }}> {row.levelId}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div style={{ display: 'flex', alignItems: 'center', paddingTop: "20px" }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <div>Conclusion:</div>
                        <div style={{ textAlign: 'center', paddingLeft: '10px' }}> {conculation} </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', paddingTop: "50px" }}>
                    <div style={{ width: '30%', textAlign: 'right' }}>
                        <p style={{ margin: 1 }}>
                            <strong>For {companyName}</strong>
                        </p>
                        <Box
                            component="img"
                            src={Signature}

                            style={{
                                maxWidth: '100px',
                                width: '100%',
                                height: Signature ? 'auto' : '100px',
                                marginBottom: 1,
                            }}
                        />
                        <p style={{ margin: 1 }}>Authorized Signatory</p>
                    </div>
                </div>

                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        marginLeft: "-20px",
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
            </div >
        </>

    );
};

const CoaPrintSecond = ({ invoiceNo, packingList, invoiceData, salesContracts, companyBanks, shippingmark, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const conculation = invoiceData?.conculation || "";
    const analyst = invoiceData?.analyst || "";
    const examiner = invoiceData?.examiner || "";
    const approved = invoiceData?.approved || "";
    const mark = packingList?.mark || "";
    const salesContractNo = salesContracts?.salesContractNo || "";

    const mfgDate = formatDateLong(invoiceData?.mfgDate || "");
    const expiryDate = formatDateLong(invoiceData?.expiryDate || "");
    const testDate = formatDateLong(invoiceData?.testDate || "");
    const quantity = invoiceData?.quantity || "";
    const packageInv = invoiceData?.package || "";

    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const productName = invoiceData?.product?.productName || '';

    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = shippingBooking?.portOfLoading || '';
    const portOfDestination = shippingBooking?.portOfDestination || '';
    // Extract particulars from invoice data
    const particulars = invoiceData?.particulars || [];
    // Map the particulars data to a format suitable for the table
    const particularData = particulars.map((particular, index) => ({
        sn: index + 1,
        items: particular.items || '',
        standard: particular.standard || '',
        result: particular.result || '',
        levelId: particular.coaLevel.title || '',
    }));
    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '50px', }}>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: '20px',
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: 'uppercase' }}>
                            Certificate of Analysis (COA)
                        </p>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            width: '100%',
                        }}
                    >
                        <div
                            style={{
                                width: '70%',
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'flex-start',
                            }}
                        >
                            <div>Marks:</div>
                            <div>
                                <span>{mark}</span>,<br />
                            </div>
                        </div>

                        <div
                            style={{
                                width: '30%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: '4px',
                                textAlign: 'left',
                            }}
                        >
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <div>Invoice No:</div>
                                <div>{invoiceNo}</div>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <div>Date:</div>
                                <div>{invoiceDate}</div>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <div>SC no.:</div>
                                <div>{salesContractNo}</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: '4px',
                        textAlign: 'left',
                    }}
                >
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                        <div  >Production Name:</div>
                        <div>{productName}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                        <div  >Batch no.:</div>
                        <div>{batchNo}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                        <div  >MFG.date:</div>
                        <div>{mfgDate}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                        <div  >Expiry date:</div>
                        <div>{expiryDate}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                        <div  >Quantity:</div>
                        <div>{quantity}</div>
                    </div>
                </div>
                <br />
                <table
                    cellPadding="8"
                    cellSpacing="0"
                    style={{
                        width: '100%',
                        fontSize: "12px",
                        borderCollapse: 'collapse',
                        borderTop: '1px solid #5A5A5A',
                        borderBottom: '1px solid #5A5A5A'
                    }}
                >
                    <thead style={{ backgroundColor: "#ededed" }}>
                        <tr>
                            <th style={{ textAlign: 'center', width: "30%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none' }}>items</th>
                            <th style={{ textAlign: 'center', width: "30%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none' }}>standard</th>
                            <th style={{ textAlign: 'center', width: "30%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none' }}>result</th>
                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "capitalize" }}>
                        {particularData.map((row, index) => (
                            <tr key={index}>
                                <td style={{ textAlign: 'center', borderLeft: 'none', borderRight: 'none' }}>{row.items}</td>
                                <td style={{ textAlign: 'center', borderLeft: 'none', borderRight: 'none' }}>{row.standard}</td>
                                <td style={{ textAlign: 'center', borderLeft: 'none', borderRight: 'none' }}>{row.result}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>


                <div style={{ display: 'flex', alignItems: 'center', paddingTop: "20px" }}>
                    <div style={{ display: 'flex', alignItems: 'center', fontWeight: "400", width: '100%', fontSize: "15px" }}>
                        <span>Conclusion:</span>
                        <span style={{ textAlign: 'center', paddingLeft: '10px' }}> {conculation} </span>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', paddingTop: "50px" }}>
                    <div style={{ width: '30%', textAlign: 'right' }}>
                        <p style={{ margin: 1 }}>
                            <strong>For {companyName}</strong>
                        </p>
                        <Box
                            component="img"
                            src={Signature}
                            style={{
                                maxWidth: '100px',
                                width: '100%',
                                height: Signature ? 'auto' : '100px',
                                marginBottom: 1,
                            }}
                        />
                        <p style={{ margin: 1 }}>Authorized Signatory</p>
                    </div>
                </div>

                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        marginLeft: "-20px",
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}

                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
            </div >
        </>

    );
};

const CoaPrintFour = ({ invoiceNo, invoiceData, companyBanks, shippingmark, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const conculation = invoiceData?.conculation || "";
    const analyst = invoiceData?.analyst || "";
    const examiner = invoiceData?.examiner || "";
    const approved = invoiceData?.approved || "";

    const mfgDate = formatDateLong(invoiceData?.mfgDate || "");
    const expiryDate = formatDateLong(invoiceData?.expiryDate || "");
    const testDate = formatDateLong(invoiceData?.testDate || "");
    const quantity = invoiceData?.quantity || "";
    const packageInv = invoiceData?.package || "";

    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const productName = invoiceData?.product?.productName || '';

    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = `${invoiceData?.loading?.portName || ""}, ${invoiceData?.loading?.country?.name || ""}`.trim();
    const portOfDestination = `${invoiceData?.destination?.portName || ""}, ${invoiceData?.destination?.country?.name || ""}`.trim();
    // Extract particulars from invoice data
    const particulars = invoiceData?.particulars || [];
    // Map the particulars data to a format suitable for the table
    const particularData = particulars.map((particular, index) => ({
        sn: index + 1,
        items: particular.items || '',
        standard: particular.standard || '',
        result: particular.result || '',
        levelId: particular.coaLevel.title || '',
    }));
    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '50px', }}>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: '20px',
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: 'uppercase' }}>
                            Certificate of Analysis (COA)
                        </p>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            width: '100%',
                        }}
                    >
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                            <div  >To:</div>
                            <div>
                                <strong>{customerName}</strong> ,<br />
                                <span>
                                    {billingStreet && `${billingStreet},`}
                                    <br />
                                    {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                    {billingPincode && ` - ${billingPincode}`}
                                </span> <br />
                                <span >Email:</span> <span>{customerEmail}</span><br />
                                <span >Mobile:</span> <span>{customerMobile}</span><br />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: '4px',
                                textAlign: 'left',
                            }}
                        >
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                                <div  >Invoice No:</div>
                                <div>{invoiceNo}</div>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                                <div  >Date:</div>
                                <div>{invoiceDate}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '16px',
                        marginTop: '20px',
                        flexWrap: 'wrap',
                    }}
                >
                    <div style={{ flex: '1' }}>
                        <span  >Port of Loading:</span>
                        <span> {portOfLoading}</span>
                    </div>
                    <div style={{ flex: '1' }}>
                        <span  >Port of Destination:</span>
                        <span> {portOfDestination}</span>
                    </div>
                    <div style={{ flex: '1' }}>
                        <span  >Route:</span>
                        <span> {shipmentTypeName}</span>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', width: '100%', }}>
                    <div style={{ height: '1px', backgroundColor: 'black', width: '100%' }} />
                    <div style={{ height: '1px', backgroundColor: 'black', width: '100%' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', paddingTop: "20px", paddingBottom: "20px" }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <div  >Product Name:</div>
                        <div style={{ textAlign: 'center', paddingLeft: '50px' }}>{productName}</div>
                    </div>
                </div>
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <tbody style={{ textTransform: "capitalize" }}>
                        <tr  >
                            <th style={{ textAlign: 'left', width: "25%", border: '1px solid #5A5A5A', fontWeight: "400" }}>Batch no.:</th>
                            <td style={{ textAlign: 'left', width: "25%", border: '1px solid #5A5A5A' }}>{batchNo}</td>
                            <th style={{ textAlign: 'left', width: "25%", border: '1px solid #5A5A5A', fontWeight: "400" }}>Package</th>
                            <td style={{ textAlign: 'left', width: "25%", border: '1px solid #5A5A5A' }}>{packageInv}</td>

                        </tr>
                        <tr>
                            <th style={{ textAlign: 'left', border: '1px solid #5A5A5A', fontWeight: "400" }}>MFG.date</th>
                            <td style={{ textAlign: 'left', border: '1px solid #5A5A5A' }}>{mfgDate}</td>
                            <th style={{ textAlign: 'left', border: '1px solid #5A5A5A', fontWeight: "400" }}>Quantity</th>
                            <td style={{ textAlign: 'left', border: '1px solid #5A5A5A' }}>{quantity}</td>

                        </tr>
                        <tr>
                            <th style={{ textAlign: 'left', border: '1px solid #5A5A5A', fontWeight: '400' }}>Expiry date</th>
                            <td style={{ textAlign: 'left', border: '1px solid #5A5A5A' }}>{expiryDate}</td>
                            <th style={{ textAlign: 'left', border: '1px solid #5A5A5A', fontWeight: '400' }}>Test date</th>
                            <td style={{ textAlign: 'left', border: '1px solid #5A5A5A' }}>{testDate}</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <thead style={{ backgroundColor: "#ededed" }}>
                        <tr>
                            <th style={{ textAlign: 'left', width: "30%" }}>items</th>
                            <th style={{ textAlign: 'left', width: "30%" }}>standard</th>
                            <th style={{ textAlign: 'left', width: "30%" }}>result</th>
                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "capitalize" }}>
                        {particularData.map((row, index) => (
                            <tr key={index}>
                                <td style={{ textAlign: 'left' }}>{row.items}</td>
                                <td style={{ textAlign: 'left' }}>{row.standard}</td>
                                <td style={{ textAlign: 'left' }}>{row.result}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div style={{ display: 'flex', alignItems: 'center', paddingTop: "20px" }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <div>Conclusion:</div>
                        <div style={{ textAlign: 'center', paddingLeft: '10px' }}> {conculation} </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', paddingTop: "50px" }}>
                    <div style={{ width: '30%', textAlign: 'right' }}>
                        <p style={{ margin: 1 }}>
                            <strong>For {companyName}</strong>
                        </p>
                        <Box
                            component="img"
                            src={Signature}

                            style={{
                                maxWidth: '100px',
                                width: '100%',
                                height: Signature ? 'auto' : '100px',
                                marginBottom: 1,
                            }}
                        />
                        <p style={{ margin: 1 }}>Authorized Signatory</p>
                    </div>
                </div>

                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        marginLeft: "-20px",
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
            </div >
        </>

    );
};

export {
    CoaPrintFirst,
    CoaPrintSecond,
    CoaPrintFour
};
